// Simple formatting for profile, video and live stream descriptions

import escape from 'lodash/escape'
import LinkifyIt from 'linkify-it'

const linkify = LinkifyIt()

export function insertLinks (txt) {
  const links = linkify.match(txt)
  if (!links || !links.length) return txt

  let offset = 0
  for (let match of links) {
    let link = `<a href="${match.url}" target="_blank">${match.text}</a>`
    txt = txt.substring(0, offset + match.index) + link + txt.substring(offset + match.lastIndex)
    offset = offset + link.length - (match.lastIndex - match.index)
  }
  return txt
}

export function linkifyHandles (txt, escaped = false) {
  if (!escaped) txt = escape(txt)
  return txt.replace(/@[A-Za-z0-9]+/g, '<a class="handle-link" href="/$&/">$&</a>')
}

export function formatText (txt) {
  if (!txt) return ''
  return linkifyHandles(insertLinks(escape(txt)), true).replace(/\r?\n/g, '<br>')
}



// WEBPACK FOOTER //
// ./src/utils/textformat.js